export default __webpack_public_path__ + "static/media/Graphik-Regular.a89b485a.ttf";